class TypeCheckUtil {
    static isNullOrUndefined(obj){
        if (typeof obj === undefined) return true
        if (obj === null) return true
        return false
    }
}
export default TypeCheckUtil; //預設匯出為靜態類別